import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/fonts/components/FeedbackToast/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/fonts/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/fonts/components/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/app/fonts.css");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/fonts/style.module.css");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/node_modules/next/dist/client/script.js");
